export const DAY_SECOND = 86400;
export const EXCHANGE_RATE = 24700;
export const ACTION = [
  {
    name: "Tạo",
    value: "CREATE",
  },
  {
    name: "Cập nhật",
    value: "UPDATE",
  },
  {
    name: "Xoá",
    value: "DELETE",
  },
  {
    name: "Lấy dữ liệu",
    value: "READ",
  },
  {
    name: "Nhập",
    value: "IMPORT",
  },
  {
    name: "Xuất",
    value: "EXPORT",
  },
];
export const RESOURCE = [
  {
    name: "Kho",
    value: "WAREHOUSE",
  },
  {
    name: "QC",
    value: "QC",
  },
  {
    name: "Lịch làm việc",
    value: "TIMESHEET",
  },
  {
    name: "Tài liệu",
    value: "DOCUMENT",
  },
];
export const PositionLevel = [
  {
    name: "Nhân viên",
    value: "STAFF",
  },
  {
    name: "Trưởng phòng",
    value: "MANAGER",
  },
  {
    name: "Lãnh đạo",
    value: "LEADER",
  },
  {
    name: "Thực tập sinh",
    value: "INTERN",
  },
];
